import {Navigate, Route, Routes} from 'react-router-dom';
import {EditBrandPage} from "../pages/edit-brand-page/edit-brand-page";
import {EditBrandBusinessProfileTab} from "../pages/edit-brand-page/tabs/edit-brand-business-profile-tab";
import {EditBrandValueAndMessagingTab} from "../pages/edit-brand-page/tabs/edit-brand-value-and-messaging-tab";
import {EditBrandComplianceTab} from "../pages/edit-brand-page/tabs/edit-brand-compliance-tab";

import {EditBrandVisualIdentityTab} from "../pages/edit-brand-page/tabs/edit-brand-visual-identity-tab";

export const BrandSettingsRoutes = () => {
  return (
    <Routes>
      <Route element={<EditBrandPage />}>
        <Route index element={<Navigate to="profile" replace />} />
        <Route path="profile" element={<EditBrandBusinessProfileTab />} />
        <Route path="value-and-messaging" element={<EditBrandValueAndMessagingTab />} />
        <Route path="visual-identity" element={<EditBrandVisualIdentityTab />} />
        <Route path="compliance" element={<EditBrandComplianceTab />} />
      </Route>
    </Routes>
  );
};
